import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class APIKeyInterceptor implements HttpInterceptor {

    constructor() { }
    
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // These headers help API's to be identified uniquely<URP - specific>
        request = request.clone({
            setHeaders : {
                UrpApiKey : 'UrpTestApiKey'
            }
        })
        return next.handle(request);
        
    }
}
